"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResultsTableRowCellsAdditionalProperty = exports.resultsTableRowCellsAdditionalPropertyDefinition = void 0;
exports.resultsTableRowCellsAdditionalPropertyDefinition = {
    view: { label: 'Results Table Row Cells Additional' },
    constraints: [
        {
            name: 'properties',
            argument: ['results-table-row-cell-additional'],
        },
    ],
    type: 'container',
    multiple: true,
    name: 'results-table-row-cells-additional',
};
const isResultsTableRowCellsAdditionalProperty = (prop) => {
    return prop.name === exports.resultsTableRowCellsAdditionalPropertyDefinition.name;
};
exports.isResultsTableRowCellsAdditionalProperty = isResultsTableRowCellsAdditionalProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0cy10YWJsZS1yb3ctY2VsbHMtYWRkaXRpb25hbC5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3Jlc3VsdHMtdGFibGUtcm93LWNlbGxzLWFkZGl0aW9uYWwucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxnREFBZ0QsR0FBRztJQUM5RCxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsb0NBQW9DLEVBQUU7SUFDckQsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsWUFBWTtZQUNsQixRQUFRLEVBQUUsQ0FBQyxtQ0FBbUMsQ0FBQztTQUNoRDtLQUNGO0lBQ0QsSUFBSSxFQUFFLFdBQVc7SUFDakIsUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsb0NBQW9DO0NBQ1gsQ0FBQTtBQUkxQixNQUFNLHdDQUF3QyxHQUFHLENBQUMsSUFBa0IsRUFBa0QsRUFBRTtJQUM3SCxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssd0RBQWdELENBQUMsSUFBSSxDQUFBO0FBQzVFLENBQUMsQ0FBQTtBQUZZLFFBQUEsd0NBQXdDLDRDQUVwRCJ9